import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/website/gallery";

export const Route = createFileRoute("/admin/_website/gallery")({
  component: Page,
});
